const MIN_PASSWORD_LENGTH = 8;

export const isRequired = (value) => {
    return !value || !value.replace(/\s/g, "").length;
};

export const isBoolNotSet = (value) => {
    return [null, undefined].includes(value);
};

export const isEmail = (value) => {
    return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value);
};

export const containsNonPrintables = (value) => {
    if (value) {
        return /[\\]/.test(JSON.stringify(value));
    }
    return false;
};

export const mustMatch = (value1, value2) => {
    return value1 !== value2;
};

export const checkPasswordLength = (password) => {
    return password.length >= MIN_PASSWORD_LENGTH;
};

export const checkPasswordVariesInCase = (password) => {
    return /(?=.*[a-z])/.test(password) && /(?=.*[A-Z])/.test(password);
};

export const checkPasswordHasSpecialChars = (password) => {
    return /(?=.*[_!@#$%^&*.-])/.test(password);
};

export const checkPasswordContainsNumber = (password) => {
    return /(?=.*[0-9])/.test(password);
};

export const validatePasswordConditions = (password) => {
    return {
        isLong: checkPasswordLength(password),
        containsNumber: checkPasswordContainsNumber(password),
        variesInCase: checkPasswordVariesInCase(password),
        hasSpecialChars: checkPasswordHasSpecialChars(password),
    };
};

export const isPasswordStrong = (password) => {
    const conditions = validatePasswordConditions(password);
    return !Object.values(conditions).every((condition) => condition);
};
